/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { useHubeeFiltresStore } from '@mairistem/administres-utils';

// Hook qui reset automatiquement les filtres Hubee quand on quitte les pages /hubee

const useHubeeFiltresReset = () => {
  const history = useHistory();
  const resetFiltres = useHubeeFiltresStore((state) => state.resetFiltres);

  React.useEffect(() => {
    // Listener sur les changements de navigation
    const unlisten = history.listen((location) => {
      const isOnHubeePage = location.pathname.startsWith('/hubee');
      // Vérifier si on est sur l'assistant en mode Hubee (avec identifiantTeledossier)
      const isOnAssistantHubee =
        location.pathname.includes('/recenses/assistant') &&
        location.search.includes('identifiantTeledossier=');

      // Si on n'est ni sur une page Hubee ni sur l'assistant Hubee, reset les filtres
      if (!isOnHubeePage && !isOnAssistantHubee) {
        resetFiltres();
      }
    });

    // Cleanup
    return () => {
      unlisten();
    };
  }, [history, resetFiltres]);
};

export default useHubeeFiltresReset;
